// extracted by mini-css-extract-plugin
export default {"button":"link_button_button__0-6wl"};